module.exports = __webpack_public_path__ + "images/fa-fw-bg-billing-mobile.webp";